module.exports = __webpack_public_path__ + "img/10.4a18d43.png";